'use client';

import { Button } from '@curology/ui-components-web/react/Button';
import React from 'react';

import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { APP_ENV } from '@/consts/environmental';
import { EmailVerificationService } from '@/services/emailVerificationService/client';

import { useNavigating } from './useNavigating';
import { useFlowContext } from '../../hooks/useFlowContext';

export const AutoVerifyEmailButton = () => {
  const { brand } = useFlowContext();
  const { onNext } = useNavigation();
  const [isNavigating, setIsNavigating] = useNavigating();

  const handleClick = async () => {
    if (isNavigating) {
      return;
    }
    setIsNavigating(true);

    await EmailVerificationService.autoVerifyEmail(brand);
    onNext();
    setIsNavigating(false);
  };

  if (APP_ENV === 'production') {
    return null;
  }

  return (
    <Button
      className="cur-w-full"
      onClick={handleClick}
      loading={isNavigating}
      buttonType="primary"
    >
      Auto-verify email
    </Button>
  );
};
